import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "relative mt-1 combobox" }
const _hoisted_2 = { class: "combobox-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z",
  fill: "none"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "relative cursor-default select-none py-2 px-4 text-gray-700"
}

import { Helpers } from '@/helper';
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, TransitionRoot } from '@headlessui/vue';
import { computed, onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  props: {
    items: { default: () => [] },
    trackBy: { default: null },
    filterBy: { default: null },
    showBy: { default: null },
    showByFunction: null,
    showClose: { type: [String, Boolean], default: false },
    placeholder: { default: 'Value' },
    modelValue: { default: '' },
    multiple: { type: Boolean, default: false },
    returnBy: { default: '' },
    inputClass: null,
    closeChevron: { type: Boolean, default: false },
    disabledInput: { type: Boolean, default: false },
    toCapitalize: { type: Boolean, default: false },
    removeDash: { type: Boolean, default: false }
  },
  emits: ["submit", "close", "update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'submit', value: string | string[]): void,
    (e: 'close', value?: string): void,
    (e: 'update:modelValue', value: string): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: any, trackBy: string | null, filterBy: string | null, showBy: string | null, showByFunction?: string | null, showClose: string | boolean, placeholder: string, modelValue: any, multiple: boolean, returnBy: string, inputClass?: string, closeChevron: boolean, disabledInput: boolean, toCapitalize: boolean, removeDash: boolean }



const modelValue = computed(() => props.modelValue)
const model = computed({
    get: () => modelValue.value,
    set: (value) => emits("update:modelValue", value),
})
const query = ref<string>('')
const items = computed(() => props.items)
const filteredItems = computed(() => {
    return query.value === '' ?
        items.value :
        items.value.filter((item: any) => {
            const itemKey = props.filterBy ? item[props.filterBy] : item
            return queryFilter(itemKey)
        })
})
const queryFilter = (str: string) => {
    return str.toLowerCase()
        .replace(/-|\s+/g, '')
        .includes(query.value.toLowerCase().replace(/-|\s+/g, ''))
}
const displayValue = (data: any) : any => {
    let str
    if (props.multiple) str = data ? data.map((d: any) => props.showBy ? ' ' + d[props.showBy] : data) : ''
    else str = data ? (props.showBy ? data[props.showBy] : data) : ''
    return Array.isArray(str) ? str : (props.removeDash ? Helpers.upperFirst(str) : Helpers.upperFirst(str).replaceAll('-', ' '))
}

const submit = () => {
    // not reactive because when click the headless ui will execute this function after update model
    // solution: give settimeout
    setTimeout(() => {
        emits('submit', model.value)
    }, 100);
}
const close = () => {
    query.value = ''
    model.value = null
    emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    nullable: "",
    multiple: __props.multiple
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ComboboxButton), { class: "focus:outline-none focus:ring-0 w-full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ComboboxInput), {
                autocomplete: "off",
                class: _normalizeClass(["combobox-input", { 'capitalize': __props.toCapitalize }]),
                placeholder: __props.placeholder,
                onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (submit()), ["enter"])),
                disabled: __props.disabledInput,
                displayValue: (data) => displayValue(data),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (query.value = $event.target.value))
              }, null, 8, ["class", "placeholder", "disabled", "displayValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(ComboboxButton), {
            class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700",
            as: "button"
          }, {
            default: _withCtx(() => [
              (__props.showClose)
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (close())),
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass([_unref(model) ? 'block' : 'hidden']),
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, _hoisted_6, 2))
                : _createCommentVNode("", true),
              (!__props.closeChevron)
                ? (_openBlock(), _createElementBlock("svg", {
                    key: 1,
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(["transform transition duration-300", { 'rotate-180': open }]),
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, _hoisted_9, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _createVNode(_unref(TransitionRoot), {
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          onAfterLeave: _cache[4] || (_cache[4] = ($event: any) => (query.value = ''))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ComboboxOptions), { class: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-2 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-30" }, {
              default: _withCtx(() => [
                (_unref(filteredItems).length === 0 && query.value !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Nothing found. "))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(filteredItems), (item, i) => {
                      return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                        key: item?.Id ? item.Id : i,
                        value: item,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (submit()))
                      }, {
                        default: _withCtx(({ selected, active }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["relative cursor-default select-none py-2 px-4 capitalize flex items-center gap-x-3", {
                            'bg-red-50 text-red-600': active || selected,
                            'text-gray-700': !active,
                        }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["block truncate text-sm", { 'font-medium': selected, 'font-normal': !selected }])
                            }, _toDisplayString(__props.removeDash ? _unref(Helpers).upperFirst(__props.trackBy ? item[__props.trackBy] : item) : _unref(Helpers).upperFirst(__props.trackBy ? item[__props.trackBy] : item).replaceAll('-', ' ')), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "multiple"]))
}
}

})